export const MAX_SIZE_UPLOAD = 5 // 5MB
export const MAX_SIZE_UPLOAD_BYTES = MAX_SIZE_UPLOAD * 1024 * 1024

export const assetSizes: Record<VideoAdditionalAssetsKeys, AssetSize> = {
  main_background: {
    width: 1400,
    height: 400,
    size: '1400x400'
  },
  secondary_background: {
    width: 960,
    height: 1600,
    size: '960x1600'
  }
}
